import {get} from 'lodash-es';

export const isWelcomeBackVisible = (state) => get(state, 'v2.ui.welcomeBack.isVisible', false);
